import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'verticalAutocomplete';

/**
 * Query hook for fetching vertical autocomplete suggestions
 */
export function useVerticalAutocompleteQuery({
	fragment,
	pageSize = 5,
	enforcePageSize = true,
	enabled = true,
}: {
	fragment: string;
	pageSize?: number;
	enforcePageSize?: boolean;
	enabled?: boolean;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled: enabled && !!fragment,
		queryFn: async () => {
			const url = Api.ImpersonationBroker.composeApiUrl({
				queryParams: { fragment, pageSize, enforcePageSize },
				urlPath: `LeadServed/vertical/autocomplete`,
			});

			const result = await userSession.webServiceHelper.callAsync<{ values: string[] }>(url, 'GET');
			return result;
		},
		queryKey: [BASE_QUERY_KEY, fragment, pageSize, enforcePageSize],
		refetchOnWindowFocus: false,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}

export function invalidateVerticalAutocomplete(fragment?: string) {
	if (fragment) {
		return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, fragment] });
	}
	return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
